module.exports = __webpack_public_path__ + "static/img/banner9.e4171de.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/banner9.png
// module id = N0et
// module chunks = 1